import React from 'react';

const FooterBorder = () => {
  return (
    <hr className="Footer__border" />
  );
};

export default FooterBorder;
